interface URLsTypes {
  GET_LIST: string;
}

const URLs: URLsTypes = {
  // Auth API's
  GET_LIST: "posts",
};

export default URLs;
